import { Component, Injector, Inject, Input, OnInit, AfterViewInit, ViewEncapsulation, ViewChildren, QueryList, ElementRef, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AbstractComponent } from '../abstract.component';
import { ItineraryData } from './itinerary-model';
import { Module } from 'projects/common/model/ModuleModel';
import { Currency } from 'projects/common/model/landingModel';
import { OfferModule } from '../offers/offer-card-data.model';
import { Device } from 'projects/common/model/Device';
import { HttpClient } from '@angular/common/http';

declare var window: any;

@Component({
  selector: 'itinerary',
  template: `
    <tag-text *ngIf="module.data.title && module.unique_id !== 'EmptyStateModule'" class="card-title" [data]="module.data.title"></tag-text>
    <tag-text *ngIf="module.data.description && module.unique_id !== 'EmptyStateModule'" class="card-description" [data]="module.data.description"></tag-text>
    <ul class="text-bullet-list eva-3-body-1">
      <li #itineraryItem *ngFor="let item of module.data.items"><span class="bullet-and-text-spacing bullet-text" [innerHTML]="item | safeHtml"></span></li>
    </ul>

    <offers *ngIf="offerModule.data?.length"
      [module]="offerModule" [currency]="currency" [flow]="flow">
    </offers>

    <div *ngIf="module.unique_id === 'EmptyStateModule'" class="empty-state-container">
      <span class="empty-state-illustration {{this.isDesktop ? 'destination-exploration-illustration' : 'marker-road-illustration'}}"></span>
      <div class="empty-state-content-container">
        <tag-text *ngIf="module.data.title" class="-eva-3-mb-md" [data]="module.data.title"></tag-text>
        <tag-text *ngIf="module.data.description" class="-eva-3-mb-md" [data]="module.data.description"></tag-text>
        <eva-button *ngIf="module.data.show_cta"  [options]="{type: '-primary', size: this.isDesktop ? '-lg' : '-md' , link_text: module.data.link.title}"
        [moduleId]="getModuleId()"
        [upaData]="{label: 'EMPTY_DESTINY_TRIPPLANNER_BTN'}"
        [showLoading]="showLoading"
        (clickEvent)="getItineraries()">
        </eva-button>
      </div>

    </div>
  `,
  styleUrls: ['./itinerary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ItineraryComponent extends AbstractComponent implements OnInit, AfterViewInit {
  @Input() override module: Module<ItineraryData>;
  @Input() moduleId: string;
  @Input() currency: Currency;
  @Input() device: Device;
  @ViewChildren('itineraryItem') itineraryItems: QueryList<ElementRef>;

  offerModule: OfferModule;
  isDesktop: boolean = false;
  showLoading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    injector: Injector,
    private httpClient: HttpClient) {
    super(injector);
  }

  ngOnInit(): void {
    this.offerModule = {
      ...(this.module as any),
      data: this.module.data.offers || []
    };
    this.isDesktop = this.device.type === "DESKTOP";
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Se trackean los clicks en elementos que contengan el atributo "trackeable"
      this.itineraryItems.forEach(item => {
        item.nativeElement.addEventListener("click", (event: any) => {
          const upaData = JSON.parse(event.target.getAttribute("data")?.replace(/\\\"/g, '"'));
          if (upaData && event.target.getAttribute("trackeable") === "true" && event.target.nodeName === 'A') {
            this.upaService.trackClickTopic({
              ...upaData,
              href: event.target.getAttribute('href')
            });
          }
        });
      });
    }
  }

  async getItineraries() {
    this.showLoading = true;
    try {
      const response = await this.httpClient.get(this.module.data.link.url).toPromise();
      // despues de crear el itinerario mando un param para que venga el tab seteado en el itinerario
      const url = new URL(window.location.href);
      url.searchParams.set('ucItineraryCreated', 'true');
      window.location.href = url.toString();
    } catch (error) {
      console.error('Error getItineraries', error);
    } finally {
      this.showLoading = false;
    }
  }

  getModuleId(): string {
    return this.moduleId;
  }
}
